import React, { Component } from 'react';
import GeckoRequest from 'services/gecko-request';
import {
  GeckoModal,
  GECKO_CONSTS,
  GeckoModalService,
  GeckoToastService,
  GECKO_UTILS,
} from 'ui';
import ToggleButtons from './FieldToggleButton';
import { splitWithUnderscore, validateKey } from 'utilities/fieldKeyUtils.js';

//TODO: ON FIELD CHANGE, ANY FIELD OPTIONS ALREADY DISPLAYED IN THE FIELD OPTIONS BOX SHOULD BE DELETED IF THE FIELD SELECTED HAS NO OPTIONS - IN RADIUS, SELECT SUBJECT AREA, MULTIPLE CHOICE - DON'T SAVE, AND THEN CHANGE THE FIELD TO ADDRESS - OPTIONS SHOULD BE GONE BUT ARE STILL SHOWING

class RadiusFieldModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: Object.assign(
        { new_field: {}, map_to_existing: true, module: 'Contacts' },
        this.props.values
      ),
      crmFields: props.crmFields,
    };
  }

  UNSAFE_componentWillMount() {
    this.getNewCRMFields(this.props.values.module || 'Contacts');
  }

  footerButtons = [
    {
      name: 'Save',
      type: 'primary',
      icon: 'far fa-save',
      handler: () => {
        if (!this.state.values.external_id) {
          return new GeckoToastService().error(
            'You must select an Integration Field to map to'
          );
        }
        if (this.state.values.map_to_existing && !this.state.values.field_id) {
          return new GeckoToastService().error(
            'You must select a Gecko Field to map your Integration Field to'
          );
        }
        if (
          !this.state.values.map_to_existing &&
          !this.state.values.new_field.type
        ) {
          return new GeckoToastService().error(
            'You must select a type for your new Gecko Field'
          );
        }
        if (!validateKey(this.state.values.key))
          return new GeckoToastService().error(
            'Key can only contain numbers or lower case letters, and must be in this format: this_is_a_valid_key'
          );
        return new GeckoModalService().close(this.state.values);
      },
    },
  ];
  getNewCRMFields(module) {
    if (!module) return;
    return GeckoRequest.get(`/integration/radius/fields/${module}`).then(
      (fields) => {
        this.setState({ crmFields: fields });
      }
    );
  }

  updateExternalId(value, newValues) {
    const crmField = this.state.crmFields.find((f) => String(f.key) === value);
    if (crmField) {
      newValues.external_label = crmField.label;
      if (crmField.options) {
        newValues.new_field.raw_options = crmField.options;
        if (!this.state.values.key && !this.state.values.map_to_existing)
          newValues.key = splitWithUnderscore(crmField.label);
      } else {
        newValues.new_field.raw_options = '';
        if (!this.state.values.key && !this.state.values.map_to_existing)
          newValues.key = splitWithUnderscore(value);
      }
    }
  }

  updateMapToExisting(value, newValues) {
    if (value) {
      newValues.key = '';
    } else {
      if (!this.state.values.key && this.state.values.external_label)
        newValues.key = splitWithUnderscore(this.state.values.external_label);
    }
  }

  updateValuesFunctionMap = {
    external_id: this.updateExternalId.bind(this),
    module: this.getNewCRMFields.bind(this),
    map_to_existing: this.updateMapToExisting.bind(this),
  };

  updateValues(key, value) {
    const newValues = GECKO_UTILS.setNestedValue(this.state.values, key, value);
    const keyHandler = this.updateValuesFunctionMap[key];
    if (keyHandler) keyHandler(value, newValues);
    this.setState({ values: newValues });
  }
  render() {
    const fields = [
      {
        key: 'module',
        label: 'Module',
        required: true,
        type: GECKO_CONSTS.FIELD_TYPE_SELECT,
        options: this.props.crmModules.map((m) => ({
          label: m.label,
          value: m.name,
        })),
        width: 'col-xs-12',
      },
      {
        key: 'external_id',
        label: 'Field',
        required: true,
        type: GECKO_CONSTS.FIELD_TYPE_SELECT,
        options: this.state.crmFields.map((f) => ({
          label: f.label,
          value: String(f.key),
        })),
        width: 'col-xs-12',
      },
      {
        key: 'map_to_existing',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        width: 'col-xs-12',
        component: <ToggleButtons />,
      },
      {
        key: 'field_id',
        label: 'Map to this Gecko contact field',
        required: true,
        type: GECKO_CONSTS.FIELD_TYPE_SELECT,
        options: this.props.fields.map((f) => ({
          label: f.label,
          value: f.id,
        })),
        hideWhen: () => !this.state.values.map_to_existing,
        width: 'col-xs-12',
      },
      {
        key: 'key',
        label: 'Key',
        description:
          'A unique name that will distinguish this field in the database from every other field. You cannot use spaces, capital letters or special characters.',
        required: true,
        hideWhen: () => this.state.values.map_to_existing,
        width: 'col-xs-12',
      },
      {
        key: 'new_field.type',
        label: 'Type',
        required: true,
        type: GECKO_CONSTS.FIELD_TYPE_SELECT,
        hideWhen: () => this.state.values.map_to_existing,
        width: 'col-xs-12',
        options: [
          {
            label: 'Text (Single Line)',
            value: GECKO_CONSTS.FIELD_TYPE_TEXT,
          },
          {
            label: 'Text (Multiple Lines)',
            value: GECKO_CONSTS.FIELD_TYPE_TEXTAREA,
          },
          {
            label: 'Email',
            value: GECKO_CONSTS.FIELD_TYPE_EMAIL,
          },
          {
            label: 'Date',
            value: GECKO_CONSTS.FIELD_TYPE_DATE,
          },
          {
            label: 'Telephone Number',
            value: GECKO_CONSTS.FIELD_TYPE_TELEPHONE,
          },
          {
            label: 'Number',
            value: GECKO_CONSTS.FIELD_TYPE_NUMBER,
          },
          {
            label: 'Single Choice',
            value: GECKO_CONSTS.FIELD_TYPE_SELECT,
          },
          {
            label: 'Multiple Choice',
            value: GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI,
          },
        ],
      },
      {
        key: 'new_field.raw_options',
        label: 'Field options in text format',
        config: { rows: 5 },
        type: GECKO_CONSTS.FIELD_TYPE_TEXTAREA,
        hideWhen: () => {
          return (
            !(
              this.state.values.new_field.type ===
                GECKO_CONSTS.FIELD_TYPE_SELECT ||
              this.state.values.new_field.type ===
                GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI
            ) || this.state.values.map_to_existing
          );
        },
        width: 'col-xs-12',
      },
      {
        key: 'new_field.raw_options',
        type: GECKO_CONSTS.FIELD_TYPE_DISPLAY,
        width: '100%',
        hideWhen: () => {
          return (
            !(
              this.state.values.new_field.type ===
                GECKO_CONSTS.FIELD_TYPE_SELECT ||
              this.state.values.new_field.type ===
                GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI
            ) || this.state.values.map_to_existing
          );
        },
        render: () => {
          return (
            <span>
              <p>Put each of your options on a new line.</p>
              <p>
                If you need your option to have a different value for your
                integration(s), write your option like:
              </p>
              <code>Label|value</code>
            </span>
          );
        },
      },
    ];

    return (
      <GeckoModal
        name={
          this.state.values.id
            ? 'Edit Integration Field'
            : 'Add New Integration Field'
        }
        fields={fields}
        values={this.state.values}
        handler={this.updateValues.bind(this)}
        btns={this.footerButtons}
      />
    );
  }
}

export default RadiusFieldModal;
